import { render, staticRenderFns } from "./ScalesManage.vue?vue&type=template&id=1a3f9fc6&scoped=true"
import script from "./ScalesManage.vue?vue&type=script&lang=js"
export * from "./ScalesManage.vue?vue&type=script&lang=js"
import style0 from "./ScalesManage.vue?vue&type=style&index=0&id=1a3f9fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f9fc6",
  null
  
)

export default component.exports